import React, { Component } from "react";
import { Switch, Route, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import AuthService from "./services/auth.service";

import Login from "./components/Login";
import Register from "./components/Register";
import AdminRegister from "./components/AdminRegister";
import Home from "./components/Home";
import Profile from "./components/Profile";
import BoardUser from "./components/BoardUser";
import BoardModerator from "./components/BoardModerator";
import BoardAdmin from "./components/BoardAdmin";
import Chat from "./components/Chat/Chat";
import SwitchLabels from "./components/SwitchLabels/SwitchLabels";
import Map from "./components/Map/Map";
import StackedBarChart from "./components/analytics/StackedBarChart"
import MyPieChart from "./components/analytics/PieChart"
import MyLineChart from "./components/analytics/MyLineChart";
import Video from "./components/Video/Video";
import Player from "./components/Video/Player";
import LogTable from "./components/analytics/LogTalble";
import RobotStatus from "./components/analytics/RobotStatus";
import ChangePassword from "./components/ChangePassword";

import Calendar from "./components/calendar/Calendar"
class App extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);

    this.state = {
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
    };
  }

  componentDidMount() {
    document.title = "Humane Cloud Platform";
    const user = AuthService.getCurrentUser();

    if (user) {
      this.setState({
        currentUser: user,
        showModeratorBoard: user.roles.includes("ROLE_MODERATOR"),
        showAdminBoard: user.roles.includes("ROLE_ADMIN"),
      });
    }
  }

  logOut() {
    AuthService.logout();
  }

  render() {
    const { currentUser, showModeratorBoard, showAdminBoard } = this.state;

    return (
      <div>
        <nav className="navbar navbar-expand navbar-dark bg-dark">
          <Link to={"/"} className="navbar-brand">
            Humane Cloud Platform
          </Link>
          <div className="navbar-nav mr-auto">
            {/* <li className="nav-item">
              <Link to={"/analytics"} className="nav-link">
              Analytics
              </Link>
            </li> */}

            {showModeratorBoard && (
              <li className="nav-item">
                <Link to={"/mod"} className="nav-link">
                  Moderator Board
                </Link>
              </li>
            )}

            {showAdminBoard && (
              <li className="nav-item">
                <Link to={"/register"} className="nav-link">
                  Register User
                </Link>
              </li>
            )}

            {currentUser && (
              <li className="nav-item">
                <Link to={"/analytics"} className="nav-link">
                  Analytics
                </Link>
              </li>
            )}

            {currentUser && (
              <li className="nav-item">
                <Link to={"/user"} className="nav-link">
                  Videos
                </Link>
              </li>
            )}

            

          {showAdminBoard && (
              <li className="nav-item">
                <Link to={"/management"} className="nav-link">
                  Management
                </Link>
              </li>
            )}

          {showAdminBoard && (
              <li className="nav-item">
                <Link to={"/map"} className="nav-link">
                  Deployment Map
                </Link>
              </li>
            )}

          </div>

          {currentUser ? (
            <div className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link to={"/changepassword"} className="nav-link">
                  {`Change Password`}
                </Link>
                
              </li>

           

              <li className="nav-item">
                <Link to={"/profile"} className="nav-link">
                  {currentUser.username}
                </Link>
              </li>
              <li className="nav-item">
                <a href="/login" className="nav-link" onClick={this.logOut}>
                  LogOut
                </a>
              </li>
            </div>
          ) : (
            <div className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link to={"/login"} className="nav-link">
                  Login
                </Link>
              </li>

              {/* <li className="nav-item">
                <Link to={"/register"} className="nav-link">
                  Sign Up
                </Link>
              </li> */}
            </div>
          )}
        </nav>

        <div className="container mt-3">
          <Switch>
            <Route exact path={["/", "/home"]} component={Home} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/register" component={Register} />
            <Route exact path="/profile" component={Profile} />
            <Route path="/user" component={Video} />
            <Route path="/chat" component={Chat} />
            <Route path="/map" component={Map} />
            <Route path="/management" component={RobotStatus} />
            <Route path="/control" component={SwitchLabels} />
            <Route path="/analytics" component={LogTable} />
            <Route path="/mod" component={BoardModerator} />
            <Route path="/changepassword" component={ChangePassword} />
            <Route path="/calendar" component={Calendar} />
            <Route path="/player/:id" component={Player} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default App;
